export default __webpack_public_path__ + "static/media/fileExcelLightOn.e9d495b1.svg";